import Modal from '../custom/Modal';
import Tabs from '../tabs/Tabs';
import Close from '../../assets/images/icons/close.svg';
import { useDispatch } from 'react-redux';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';

const InfoModal = () => {
	const dispatch = useDispatch();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.INFO_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal}>
			<div className="modal-actions">
				<div className="modal-actions-close" onClick={handleOnCloseModal}>
					<img className="modal-close" src={Close} alt="Close" />
				</div>
			</div>
			<Tabs />
		</Modal>
	);
};

export default InfoModal;
